import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getPhoneOptions } from '@services/cpqService';
import { useCheckoutStore } from '@store/checkoutStore';
import type { PhoneFormValues } from '@t/checkout.types';

export const useHydratePhoneInfo = (
  sessionId: string | null,
  hasPhonePlan: boolean,
  savedPhoneInfo: PhoneFormValues | null
): void => {
  const setPhoneInfo = useCheckoutStore((s) => s.setPhoneInfo);

  const { data: existingPhoneOptions } = useQuery({
    queryKey: ['existingPhoneOptions', sessionId],
    queryFn: () => getPhoneOptions(sessionId!),
    enabled: !!sessionId && !savedPhoneInfo && hasPhonePlan,
    retry: false,
  });

  useEffect(() => {
    if (!existingPhoneOptions || savedPhoneInfo) return;

    const isOther = existingPhoneOptions.serviceProvider === 'Other';
    const hydrated: PhoneFormValues = {
      choice: existingPhoneOptions.selectedOption ?? 'NEWNUMBER',
      portInNumber: existingPhoneOptions.existingPhoneNumber ?? '',
      portInProvider: isOther ? 'Other' : (existingPhoneOptions.serviceProvider ?? ''),
      portInProviderOther: isOther ? (existingPhoneOptions.providerName ?? '') : '',
      accountNumber: existingPhoneOptions.accountNumber ?? '',
      nameOnBill: existingPhoneOptions.nameOnBill ?? '',
      directoryListing: existingPhoneOptions.directoryListingOption ?? 'Listed',
      phoneBillFiles: [],
      existingPhoneBillFiles: existingPhoneOptions.phoneBillFiles ?? [],
    };

    setPhoneInfo(hydrated);
  }, [existingPhoneOptions, savedPhoneInfo, setPhoneInfo]);
};
